<template>
    <div class="row-box">
        <div
            class="row"
            :class="{isHide: item.isHide}"
            v-for="(item, index) in newForm"
            :key="index"
        >
            <p v-if="item.name" class="name">{{item.name}}</p>
            <div v-if="item.type === 'Btns'">
                <Btns
                    :form.sync="item.buttonArray"
                    @onBtns="onBtns(index, $event, item)"
                />
            </div>
            <div class="radio-box" v-else-if="item.type === 'Switch'">
                <el-radio-group v-model="item.value"
                                size="small"
                                @click.native.stop="onBtns(index, item)"
                >
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </div>
            <div v-else-if="item.type === 'InputNumber'">
                <el-input-number
                    v-model="item.value"
                    v-bind="item"
                    size="mini"
                    placeholder="请输入"
                    @change="onBtns(index, item)"
                ></el-input-number>
            </div>
            <div v-else-if="item.type === 'Input'">
                <el-input
                        v-model="item.value"
                        v-bind="item"
                        size="mini"
                        placeholder="请输入内容"
                        @change="onBtns(index, item)"
                ></el-input>
            </div>
        </div>
    </div>
</template>

<script>
    import Btns from './components/Btns'
    export default {
        name: "RowBox",
        components: {
            Btns
        },
        props: {
            form: [Object,Array]
        },
        width: {
            form:{
                handler(vl){
                    this.newForm=vl
                },
                deep: true,
                immediate: true
            },
            newForm:{
                handler(vl){
                    this.$emit('update:form', vl)
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                newForm: this.form
            }
        },
        methods: {
            onBtns (index, item, parentItem){
                console.log(777)
                this.$emit('onBtns', { parentId: index, ...item, parentItem })
            }
        }
    }
</script>

<style lang="scss" scoped>
.row-box{
    display: flex;

    .row{
        font-size: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;

        &.isHide{
            display: none;
        }

        .name{
            margin-right: 10px;
        }

        .radio-box {
            /deep/ .el-radio{
                margin-right: 0px;
                margin-left: 10px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner {
                border-color: #e7622e;
                background: white;
            }
            /deep/ .el-radio__input.is-checked + .el-radio__label{
                color: #e7622e;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner::after{
                transform: translate(-50%,-50%) scale(2);
                background-color: #e7622e;
            }
        }
    }
}
</style>
